// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RgCe","type":"styles_type__3LOEc","choices":"styles_choices__WD9UX"};